import clsx from 'clsx';

import styles from './SpinnerView.module.css';

type TSpinnerView = {
  'data-testid'?: string;
  className?: string;
};

export default function SpinnerView({
  'data-testid': dataTestId = 'spinner',
  className = '',
}: TSpinnerView) {
  return (
    <div className={clsx(styles.root, className)} data-testid={dataTestId}>
      <i className={`${styles.icon} fas fa-spinner-third fa-spin`} />
    </div>
  );
}
